// src/assets/images/profileIcons.tsx
import React from 'react';

export const ProfileIcons = {
    // История операций (книга)
    history: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4H16C17.1 4 18 4.9 18 6V18C18 19.1 17.1 20 16 20H4V4Z"
                  stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <path d="M18 6H20V20H6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
            <path d="M8 8H14M8 12H12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
            <path d="M8 16H10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
    ),

    // Реферальная программа (сердечко с плюсиком/приглашением)
    referral: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
                  stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <path d="M12 8V14M9 11H15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
    ),

    // Промокод (звездочка)
    promo: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L14.5 8.5L21 9L16 13.5L18 20L12 16.5L6 20L8 13.5L3 9L9.5 8.5L12 2Z"
                  stroke="currentColor" strokeWidth="1.6" fill="none"/>
        </svg>
    ),

    // Поддержка (чат)
    support: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                  stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <circle cx="8" cy="10" r="1.5" fill="currentColor"/>
            <circle cx="12" cy="10" r="1.5" fill="currentColor"/>
            <circle cx="16" cy="10" r="1.5" fill="currentColor"/>
        </svg>
    ),

    // Пользовательское соглашение (документ)
    agreement: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6C5.5 2 5 2.5 5 3V21C5 21.5 5.5 22 6 22H18C18.5 22 19 21.5 19 21V8L14 2Z"
                  stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <path d="M14 2V8H19" stroke="currentColor" strokeWidth="1.6"/>
            <path d="M9 13H15M9 17H12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
    ),

    // Установка на другие устройства (простая флешка)
    install: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7" y="6" width="10" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <circle cx="12" cy="11" r="1" fill="currentColor"/>
            <circle cx="12" cy="15" r="1" fill="currentColor"/>
        </svg>
    ),

    // Копирование
    copy: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="1.6" fill="none"/>
            <path d="M5 15H4C2.9 15 2 14.1 2 13V4C2 2.9 2.9 2 4 2H13C14.1 2 15 2.9 15 4V5"
                  stroke="currentColor" strokeWidth="1.6"/>
        </svg>
    ),

    // Галочка (успех)
    check: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
    ),

    // Стрелка вправо (для навигации)
    chevronRight: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
        </svg>
    ),

    add: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),

    edit: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 21H21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
            <path d="M14.06 2.94C14.3431 2.65688 14.7341 2.51104 15.1364 2.54819C15.5387 2.58535 15.9091 2.80208 16.15 3.15L18.85 6.85C19.086 7.189 19.199 7.604 19.171 8.027C19.143 8.45 18.977 8.856 18.7 9.2L7 21H3V17L14.06 2.94Z"
                  stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
};